function normalizeText(value) {
  return String(value ?? '').trim();
}

function normalizeWeight(value) {
  if (value === '' || value == null) {
    return null;
  }
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : null;
}

export function normalizeGuidWeightMap(weights) {
  if (!weights || typeof weights !== 'object' || Array.isArray(weights)) {
    return {};
  }
  const out = {};
  for (const [k, v] of Object.entries(weights)) {
    const key = normalizeText(k);
    if (!key) continue;
    const nw = normalizeWeight(v);
    if (nw !== null) out[key] = nw;
  }
  return out;
}

/** Baseline display number for standard weight fields (invalid/missing → 1). */
export function standardWeightDisplayNumber(w) {
  const n = Number(w);
  return Number.isFinite(n) ? n : 1;
}

export function standardWeightPlaceholderString(w) {
  return String(standardWeightDisplayNumber(w));
}

/**
 * @returns {number|null} null = inherit / not set in override map
 */
export function normalizeOverrideMapValue(v) {
  if (v == null || v === '') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

/** Raw map value for controlled number input; empty string when inheriting. */
export function overrideMapInputValue(weights, nodeGuid) {
  const raw = weights?.[nodeGuid];
  if (raw == null) return '';
  const n = Number(raw);
  return Number.isFinite(n) ? n : '';
}

export function overrideMapControlledInputValue(weights, nodeGuid) {
  const v = overrideMapInputValue(weights, nodeGuid);
  return v === '' ? '' : v;
}

/** Updates a guid → weight map (standalone override / org custom weights). */
export function setGuidWeightMapEntry(weights, nodeGuid, weight) {
  const base =
    weights && typeof weights === 'object' && !Array.isArray(weights)
      ? { ...weights }
      : {};
  const useInherit =
    weight == null || (typeof weight === 'number' && !Number.isFinite(weight));
  if (useInherit) {
    delete base[nodeGuid];
  } else {
    base[nodeGuid] = weight;
  }
  return base;
}
